module.exports = __webpack_public_path__ + "static/media/PTTA-final.0a7efd07.mp3";